'use client';

import React from 'react';
import { ThemeProvider } from 'styled-components';
import themes, { defaultTheme } from '../../theme/themes';
import { config } from '../../utils/config';

export const ThemeWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const theme = themes.find(({ version }) => version === config.theme) || defaultTheme;
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
